module.exports = __webpack_public_path__ + "media/images/lp/logo_sumasate-d8ae902243052b2af705e88a552dcff6.svg";